import { toast } from "react-toastify";
import copy from "copy-to-clipboard";

export const copyStringToClipboard = (str, callback) => {
    try {
        const text = typeof str !== "string" ? String(str) : str;

        copy(text);
        toast.success("copied");

        if(callback){
            callback();
        }
    } catch (err) {
        toast.error("Oops! Something went wrong, we can not copy this data");
    }
};
